var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "judge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5403 19.04C20.3903 19.19 20.2003 19.26 20.0103 19.26C19.8203 19.26 19.6303 19.19 19.4803 19.04L14.5303 14.09L15.0603 13.56L15.5903 13.03L20.5403 17.98C20.8303 18.27 20.8303 18.75 20.5403 19.04Z",
    fill: "#2E1962"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.47035 9.27997L12.2704 15.08C12.6604 15.47 12.6604 16.1 12.2704 16.49L11.3704 17.4C10.5604 18.2 9.28035 18.2 8.48035 17.4L4.14035 13.06C3.35035 12.27 3.35035 10.98 4.14035 10.18L5.05035 9.26997C5.44035 8.88997 6.08035 8.88997 6.47035 9.27997Z",
    fill: "#2E1962"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.5898 10.1901L14.7798 13.9901C14.3798 14.3901 13.7398 14.3901 13.3398 13.9901L7.55977 8.21005C7.15977 7.81005 7.15977 7.17005 7.55977 6.77005L11.3698 2.96005C12.1598 2.17005 13.4498 2.17005 14.2498 2.96005L18.5898 7.30005C19.3798 8.10005 19.3798 9.38005 18.5898 10.1901Z",
    fill: "#2E1962"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8 21.75H2C1.59 21.75 1.25 21.41 1.25 21C1.25 20.59 1.59 20.25 2 20.25H8C8.41 20.25 8.75 20.59 8.75 21C8.75 21.41 8.41 21.75 8 21.75Z",
    fill: "#2E1962"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderActive);
export default __webpack_public_path__ + "static/media/order-active.da4b492f6e479d439c5672ab23da53e5.svg";
export { ForwardRef as ReactComponent };